import {
  Input as BaseWebInput,
  InputProps,
  InputOverrides,
} from 'baseui/input';
import React from 'react';

const overrides: InputOverrides = {
  Root: {
    style: () => ({
      borderTopColor: '',
      borderBottomColor: '',
      borderLeftColor: '',
      borderRightColor: '',
      borderTopStyle: 'none',
      borderBottomStyle: 'none',
      borderLeftStyle: 'none',
      borderRightStyle: 'none',

      backgroundColor: '#191A1E',

      borderBottomLeftRadius: '20px',
      borderBottomRightRadius: '20px',
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
    }),
  },
  Input: {
    style: ({ $error, $disabled }) => ({
      backgroundColor: '#191A1E',
      color: $disabled ? '#A6A6A6' : $error ? '#FB5656' : '#A6A6A6',
      fontSize: '14px',
      fontFamily: 'var(--font-gt-planar)',
      paddingLeft: 0,
      textAlign: 'left',
    }),
  },
  StartEnhancer: {
    style: ({ $theme }) => ({
      backgroundColor: '#191A1E',
      fontWeight: $theme.typography.font150.fontWeight,
      fontSize: $theme.sizing.scale600,
      letterSpacing: '0.2px',
      flexShrink: 0,
      color: $theme.colors.white,
      paddingLeft: 0,
    }),
  },
  EndEnhancer: {
    style: ({ $theme }) => ({
      cursor: 'pointer',
      backgroundColor: '#191A1E',
      fontWeight: $theme.typography.font150.fontWeight,
      fontSize: $theme.sizing.scale600,
      letterSpacing: '0.2px',
      flexShrink: 0,
      color: $theme.colors.contentTertiary,
      paddingRight: 0,
    }),
  },
};

export function Input(props: InputProps) {
  return <BaseWebInput overrides={overrides} {...props} />;
}
